import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        const sessionId = m ? decodeURIComponent(m[1]) : null;

        if (!sessionId) {
            navigate("/admin/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post(
                    "/auth/session",
                    { session_id: sessionId },
                    { withCredentials: true }
                );
                await refresh();
                // Clear hash and go to admin dashboard
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/admin", { replace: true, state: { user: data.user } });
            } catch (e) {
                const msg = e?.response?.data?.detail || "Sign-in failed.";
                setError(msg);
            }
        })();
    }, [navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F2E8D5] p-6" data-testid="auth-callback">
            <div className="bg-brand-cream rounded-3xl border border-stone-200 p-10 max-w-md w-full text-center shadow-xl">
                {error ? (
                    <>
                        <h2 className="font-serif text-3xl text-brand-red">Access denied</h2>
                        <p className="mt-3 text-stone-600">{error}</p>
                        <button
                            onClick={() => navigate("/admin/login", { replace: true })}
                            data-testid="auth-callback-back"
                            className="mt-6 px-5 py-2 rounded-full bg-brand-purple text-white"
                        >
                            Back to login
                        </button>
                    </>
                ) : (
                    <>
                        <Loader2 className="mx-auto animate-spin text-brand-purple" size={42} />
                        <h2 className="font-serif text-2xl mt-4">Signing you in...</h2>
                        <p className="text-stone-500 mt-2 text-sm">Verifying your access.</p>
                    </>
                )}
            </div>
        </div>
    );
}
